import React from 'react'
import { withRouter } from 'react-router-dom'

import Moment from 'moment'

import FAIcon from '../FAIcon'

import 'react-big-calendar/lib/sass/styles.scss'
// Reuse the styles from the main component
import './CalendarEventComponent.scss'

const CalendarAgendaEventComponent = ({ event, history }) => {
  if (!event) return null
  const isDayInPast = Moment.utc(event.end) < Moment.utc()
  // const isOverdue = event.type === 'Task' && !event.isComplete && Moment.utc(event.start) < Moment.utc()

  // Icon logic
  const icon = event.type === 'Task' ? 'calendar-check' : 'calendar-day'
  const isTaskComplete = event.type === 'Task' && event.isComplete

  const handleClick = e => {
    e.stopPropagation() // Prevent bubbling if necessary

    // Navigation logic duplicated from CalendarPage
    const fromPath = `${history.location.pathname}${history.location.search || ''}`
    if (event.type === 'Appointment') {
      history.push({
        pathname: `/cases/${event.caseNumber}/appointments/${event.id}`,
        state: { from: fromPath },
      })
    } else if (event.type === 'Task') {
      if (event.caseNumber) {
        history.push({
          pathname: `/cases/${event.caseNumber}/tasks/${event.id}`,
          state: { from: fromPath },
        })
      } else {
        history.push({
          pathname: `/tasks/${event.id}`,
          state: { from: fromPath },
        })
      }
    }
  }

  const handleDuplicateClick = e => {
    e.preventDefault()
    e.stopPropagation()
    const fromPath = `${history.location.pathname}${history.location.search || ''}`
    if (event.type === 'Appointment' && event.caseNumber && event.id) {
      history.push({
        pathname: `/cases/${event.caseNumber}/appointments`,
        search: `?duplicateFrom=${event.id}`,
        state: {
          duplicateAppointment: event.resource,
          from: fromPath,
        },
      })
    } else if (event.type === 'Task' && event.id) {
      if (event.caseNumber) {
        history.push({
          pathname: `/cases/${event.caseNumber}/tasks`,
          search: `?duplicateFrom=${event.id}`,
          state: {
            duplicateTask: event.resource,
            from: fromPath,
          },
        })
      } else {
        history.push({
          pathname: `/tasks/new`,
          search: `?duplicateFrom=${event.id}`,
          state: {
            duplicateTask: event.resource,
            from: fromPath,
          },
        })
      }
    }
  }

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div
      className="calendar-event-component-container agenda-event-container d-flex align-items-center justify-content-between w-100 h-100"
      onClick={handleClick}
      style={{ cursor: 'pointer', height: '100%' }}
    >
      <div className="d-flex align-items-center flex-grow-1" style={{ minWidth: 0 }}>
        <FAIcon name={icon} className={`mr-2 flex-shrink-0 ${isDayInPast ? 'text-muted' : ''}`} />
        {isTaskComplete && <span className="task-complete-check mr-1 flex-shrink-0">&#10003;</span>}

        <div className="event-content-container flex-grow-1" style={{ minWidth: 0 }}>
          <span className={`event-title mb-0 ${isDayInPast ? 'grayed-text' : ''}`}>{event.title}</span>
        </div>
      </div>
      {(event.type === 'Appointment' || event.type === 'Task') && event.id && (
        <button
          type="button"
          className="calendar-event-duplicate-btn flex-shrink-0 ml-2"
          title={`Duplicate this ${event.type.toLowerCase()}`}
          aria-label={`Duplicate this ${event.type.toLowerCase()}`}
          onClick={handleDuplicateClick}
        >
          <FAIcon name="copy" />
        </button>
      )}
    </div>
  )
}

export default withRouter(CalendarAgendaEventComponent)
